export default "__VITE_ASSET__BLKpUzvI__"